<app-page-header [heading]="'Warehouse Report'" [icon]="'fa-home'" style="height:100px;"></app-page-header>
<div *ngIf="user_rights.ADD == '1'" class="page-panel">
  <div class="clearfix"></div>
  <div class="row ">
    <div class="col-lg-12 ">
      <div class="mw-100 d-flex ">
        <div class="col-lg-8"></div>
        <div class="col-lg-4">
          <div class="row">
            <div class="input-group ">
              <input (keydown)="keyDownFunction($event)" [(ngModel)]="search_text" class="form-control"
                     id="typeahead-http" name="search_text"
                     placeholder="Item / Product Code" style="height:31px" type="text">
              <div class="input-group-append">
                <button class="input-group-text" style="height:31px;padding:7px">
                  <i class="fa fa-search"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="clearfix"></div>
      <div class="">
        <table class="table tbl table-hover table-bordered" style="background-color: #f3f8fd">
          <thead class="text-center">
          <tr>
            <th width="1%">Sl</th>
            <th>Item</th>
            <th *ngFor="let stock of stock_data " class="text-center">{{ stock.WAREHOUSE_NAME }}</th>
            <th width="15%">Total</th>
          </tr>
          <tr *ngIf="(warehouse_data | json) == '[]'">
            <td class="text-center" colspan="7">No data to list</td>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let warehouse of warehouse_data; let i=index">
            <td class="text-center">{{ i + 1 }}</td>
            <td><a routerLink="/report/warehouse-stock-log/{{warehouse.MEDICINE_ID}}">{{ warehouse.TRADE_NAME }} </a>
            </td>
            <ng-container *ngFor="let stock of stock_data ">
              <td class="text-center">
                <ng-container *ngFor="let quantity of warehouse.WAREHOUSE">
                  <ng-container *ngIf="quantity.WAREHOUSE_ID == stock.WAREHOUSE_ID">
                    <button
                      (click)="open(damaged);listWarehouse(quantity.WAREHOUSE_ID);listWarehousepurchaseReport(quantity,warehouse.MEDICINE_ID,quantity.WAREHOUSE_ID)"
                      style="cursor: pointer"> {{ quantity.WAREHOSE_AVAILABLE_QUANTITY }}
                    </button>
                  </ng-container>
                </ng-container>
              </td>
            </ng-container>
            <td class="text-center">{{ warehouse.total_amount }}</td>
          </tr>
          </tbody>
          <tfoot>

          </tfoot>
        </table>
      </div>
    </div>
  </div>
</div>

<ng-template #damaged let-modal>
  <div class="modal-header">
    <div class="pull-right">
      <h5 class="modal-title" id="modal-basic-title">
        {{ medicine }}
      </h5>
    </div>
    <button (click)="modal.dismiss('Cross click')" aria-label="Close" class="close" type="button">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="tab-pane active">
      <div class="tab-content">
        <div class="panel-body">
          <table class="table tbl table-striped table-bordered">
            <thead>
            <tr class="text-center">
              <th width="1%"></th>
              <th width="2%">Sl</th>
              <th class="text-left" width="20%">Invoice No</th>
              <th width="8%">Quantity</th>
              <th width="10%">Move</th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let data of purchase_data;let i=index">
              <td class="text-center"><input (click)="changeCheckbox(i)" *ngIf="data.WAREHOSE_AVAILABLE_QUANTITY >0"
                                             [(ngModel)]="data.check"
                                             type="checkbox"></td>
              <td class="text-center">{{ i + 1 }}</td>
              <td class="text-left">{{ data.INVOICE_NUMBER }}</td>
              <td class="text-center">{{ data.WAREHOSE_AVAILABLE_QUANTITY }}</td>
              <td><input (focusout)="checkquantity();" [(ngModel)]="warehouse_move_data.move_qty[i]"
                         [disabled]="data.check == 0"
                         class="form-control " name="move_qty{{i}}"
                         type="text"></td>
            </tr>
            </tbody>
            <tfoot>
            <td class="text-right" colspan="3">Total</td>
            <td class="text-center">{{ total_available_qty }}</td>
            <td>{{ total_move_qty }}</td>
            </tfoot>
          </table>
          <div class="clearfix"></div>
          <div class="row">
            <div class="form-group col-lg-6">
              <label>Move From</label>
              <input [readOnly]="true" class="form-control " maxlength="10" name="state_code" type="text"
                     value="{{warehouse_name}}">
            </div>
            <div class="form-group col-lg-6">
              <label>Move To</label><span class="text-danger">&nbsp;*</span>
              <select [(ngModel)]="warehouse_move_data.move_warehouse_id"
                      class="form-control  custom-select custom-select-sm"
                      name="move_warehouse_id">
                <option value=0>Select Warehouse</option>
                <option *ngFor="let data of warehouse_warehouse"
                        value="{{data.WAREHOUSE_ID}}">{{ data.WAREHOUSE_NAME }}
                </option>
              </select>
            </div>
          </div>
        </div>

        <div class="modal-footer">

          <button (click)="modal.dismiss('Cross click');" class="btn-danger btn  btn-sm">Cancel</button>
          <button (click)="savemoveWarehouse()" class="btn-info btn  btn-sm" title="save">Save</button>
        </div>
      </div>
    </div>
  </div>
</ng-template>
